module.exports = "<div class=\"badge\" [ngClass]=\"getClasses()\" [ngStyle]=\"getStyles()\">\r\n  <div class=\"arrow\" [ngClass]=\"getArrowClasses()\" *ngIf=\"arrow\"></div>\r\n  <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ni-components/badge/badge.component.html
// module id = ../../../../../src/app/ni-components/badge/badge.component.html
// module chunks = 39